import { Fancybox } from '@fancyapps/ui';
import axios from 'smg/axios';
import { SetBootstrapVersion } from 'smg/bootstrap';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as session from 'smg/customer-api/session';
import * as errors from 'smg/errors';
import * as html from 'smg/html';
import { SetIconLibrary } from 'smg/icons';
import * as modals from 'smg/modal';
import { G } from 'smg/querystring';
import * as carts from './carts';
import AccountSettings from './pages/accountsettings';
import AllPricing from './pages/allpricing';
import Cart from './pages/cart';
import ChangePassword from './pages/changepassword';
import Checkout from './pages/checkout';
import Contact from './pages/contact';
import Dashboard from './pages/dashboard';
import Faq from './pages/faq';
import Forgot from './pages/forgot';
import Join from './pages/join';
import Login from './pages/login';
import LoginEmail from './pages/loginemail';
import OrderDetails from './pages/order-details';
import Orders from './pages/orders';
import OrderSubmitted from './pages/ordersubmitted';
import PasswordReset from './pages/passwordreset';
import PaymentMethods from './pages/payment-methods';
import PaymentHistory from './pages/paymenthistory';
import Quote from './pages/quote';
import Quotes from './pages/quotes';
import Revisions from './pages/revisions';
import ShippingAddresses from './pages/shipping-addresses';
import TaxExemptions from './pages/tax-exemptions';
import Tracking from './pages/tracking';
import Uploads from './pages/uploads';

import './featured-products';
import './nav';
import './pricing-table';

import './pages/free-quote/index';
import './pages/gallery';
import './pages/rush-pin-quote-form';
import './pages/trading-pin-quote-form';

void GetPageRequestID();

SetIconLibrary('fontAwesome4');
SetBootstrapVersion(5);

modals.SetDefaults({
    appendButtonClass: 'text-white',
    // animation: true,
});

errors.Defaults.ShowErrorFunc = msg => new modals.default({
    body: html.FromString(`<div>
            <i class="fas fa-exclamation-circle w-100 text-center mb-5 fa-5x text-danger"></i>
            <div class="fs-4 text-center">${html.Escape(msg)}</div>
        </div>`),
    cancelText: 'Close',
});

Fancybox.bind('[data-fancybox]', {
    Images: {
        content: (_, slide) => {
            const $picture = document.createElement('picture');

            if (slide.triggerEl?.dataset.srcsetWebp) {
                const $sourceWebp = document.createElement('source');
                $sourceWebp.srcset = slide.triggerEl.dataset.srcsetWebp;
                $sourceWebp.type = 'image/webp';
                $picture.appendChild($sourceWebp);
            }

            const $img = document.createElement('img');
            $img.src = String(slide.src ?? '');
            $picture.appendChild($img);

            if (slide.triggerEl?.dataset.srcset) {
                $img.srcset = slide.triggerEl.dataset.srcset;
            }

            return $picture;
        },
    },
});

function initSession() {
    const navLogin = document.querySelectorAll('.nav-login');
    const loggedIn = document.querySelectorAll('.loggedIn');
    if (session.GetLoginToken()) {
        session.Session().then(sess => {
            const navName = document.querySelectorAll('.nav-name');

            navName.forEach(el => {
                el.textContent = `${sess.firstName} ${sess.lastName}`.trim() || sess.company || 'My Account';
            });

            const navSession = document.querySelector('#nav-session-item') as HTMLElement;
            if (navSession) {
                navSession.classList.remove('d-none');
            }

            document.querySelectorAll('.logout').forEach(e => e.addEventListener('click', e => {
                e.preventDefault();

                void axios.delete('/sessions').then(() => {
                    session.ClearLoginToken();
                    window.location.reload();
                });
            }));

            loggedIn.forEach(el => {
                el.classList.remove('d-none');
            });
        }).catch(err => {
            navLogin.forEach(el => {
                el.classList.remove('d-none');
            });
            throw err;
        });
    } else {
        navLogin.forEach(el => {
            el.classList.remove('d-none');
        });
    }
}

function initCart() {
    if (carts.GetCartID()) {
        void carts.GetCartCount().then(count => {
            if (!count) {
                return;
            }

            carts.IncrementCartCount(count);
        });
    }
}

async function main() {
    const loginToken = G().Get('loginToken');
    if (loginToken) {
        G().Delete('loginToken');

        await session.CreateSessionWithLoginToken(loginToken).catch(err => console.warn(err));
    }

    if (G().Get('paypal') === 'success') {
        const successAlert = document.querySelector('#paypal-success') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            G().Delete('paypal');
        });
    }

    if (G().Get('paypal') === 'error') {
        const successAlert = document.querySelector('#paypal-error') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            G().Delete('paypal');
        });
    }

    if (G().Get('deleteCart')) {
        void carts.DeleteCart();
        G().Delete('deleteCart');
    }

    // Sidebar to show on large screens
    const accountSidebar = document.querySelector('#account-links') as HTMLElement;
    if (accountSidebar) {
        if (window.innerWidth >= 992) {
            accountSidebar.classList.add('show');
        }
    }

    // Header Alignment Fix
    const btnGroup = document.querySelector('.button-group') as HTMLElement;
    const phoneGroup = document.querySelector('.phone-group') as HTMLElement;

    if (btnGroup && phoneGroup) {
        window.addEventListener('resize', () => {
            phoneGroup.style.width = `${btnGroup.offsetWidth}px`;
        });
    }

    switch (document.body.id) {
    case 'login':
        Login();
        break;
    case 'login-email':
        LoginEmail();
        break;
    case 'join':
        Join();
        break;
    case 'track':
        void OrderDetails();
        break;
    case 'orders':
        void Orders();
        break;
    case 'order-submitted':
        void OrderSubmitted();
        break;
    case 'payment-history':
        void PaymentHistory();
        break;
    case 'uploads':
        void Uploads();
        break;
    case 'change-password':
        void ChangePassword();
        break;
    case 'quotes':
        void Quotes();
        break;
    case 'tracking':
        void Tracking();
        break;
    case 'cart':
        void Cart();
        break;
    case 'revisions':
        void Revisions();
        break;
    case 'checkout':
        void Checkout();
        break;
    case 'forgot':
        Forgot();
        break;
    case 'password-reset':
        PasswordReset();
        break;
    case 'account-settings':
        void AccountSettings();
        break;
    case 'dashboard':
        void Dashboard();
        break;
    case 'quote':
        Quote();
        break;
    case 'contact':
        Contact();
        break;
    case 'shipping-addresses':
        void ShippingAddresses();
        break;
    case 'payment-methods':
        void PaymentMethods();
        break;
    case 'tax-exemptions':
        void TaxExemptions();
        break;
    case 'faq':
        Faq();
        break;
    case 'all-pricing':
        void AllPricing();
        break;
    }

    initSession();
    initCart();
}

void main();